module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/73/assets/images/6834bf40d91e6914f233afecd827b2d9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_expand_large.svg
// module id = kmmW
// module chunks = 0